import { render, staticRenderFns } from "./fleetDriver.vue?vue&type=template&id=5d5fb058&scoped=true&"
import script from "./fleetDriver.vue?vue&type=script&lang=js&"
export * from "./fleetDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5fb058",
  null
  
)

export default component.exports